import { MetaImage } from '~/components/Metadata/Metadata.types'
import { AppLanguage } from '~/types/locale'

type CommonTopicData = TopicData & {
  title: string
  key: string
  // Real content-modification date (YYYY-MM-DD) from the pipeline — not Sanity's _updatedAt sync timestamp
  lastmod?: string
  metaDescription: string
  breadcrumbs: TopicData[]
  image?: MetaImage
  locale: AppLanguage
  type: TheoryType
  language: AppLanguage
  siblings: TopicData[]
  shouldRenderChildren?: true
  otherLocales: AppLanguage[]
  sharedLanguageKey: string
  localeSiblings?: Array<{ language: string; slug: string }>
}

export interface TopicData {
  h1: string
  path: string
}

export type TopicOverview = TopicData & {
  shouldRenderChildren?: true
  children?: TopicOverview[]
}

export type PreviewTopic = TopicData & {
  smallPreviewUrl: string
}

interface FileOnlyTopicData {
  previewUrl: string
  smallPreviewUrl: string
  cssUrl: string
  htmlContent: { html: string }
  taskReference?: { taskId: string }
}

export type FileTopic = CommonTopicData & FileOnlyTopicData

export type TopTopic = CommonTopicData & { isRootPath?: true }

export type Topic = TopTopic | FileTopic

export enum TheoryType {
  ENCYCLOPEDIA = 'encyclopedia',
  GEOGEBRA = 'geogebra',
  EXCEL = 'excel',
  DRILL = 'drill',
}

export interface SimpleTopic {
  h1: string
  path: string
  previewUrl?: string
}

export type TopicGroq = Topic & { children?: SimpleTopic[] }
export type DrillTopicOverview = Topic & { children: TopicData[] }

export interface Redirect {
  source: Path
  destination: Path
  query: string
}

export interface Path {
  path: string
  language: AppLanguage
  slug?: boolean
}

// Result of theoryAltLanguagePathGroq: the same-path topic in another language,
// plus (when sharedLanguageKey links them) its requested-language translation.
export type AltLanguagePath = Path & { translated?: Path }
